var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.addressClass)?_c('img',{staticClass:"address-class store-logo",attrs:{"src":_vm.src,"height":"26","contain":"","alt":`logo ${_vm.addressClass.name}`,"title":`${_vm.addressClass.name}`}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }